import { getCrmPalette } from './brand';

// Paleta de la marca activa del CRM (Booster emerald por defecto), resuelta una
// vez al cargar. Drop-in para los widgets que antes importaban IMPERIUM_PALETTE:
//   - import { IMPERIUM_PALETTE as P } from '../../theme/palette';
//   + import { CRM_PALETTE as P } from '../../theme/brandPalette';
// Mantiene la MISMA forma de objeto, así que el resto del código no cambia.
export const CRM_PALETTE = getCrmPalette();
